// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__mHw63","signatureButtonsRight":"ModalSign_signatureButtonsRight__2LfJJ"};